/**
 * Paths for the dedicated single-table pages.
 *
 * Kept in one place so the "Full view" button and Routes.js can never drift
 * apart. These are intentionally NOT registered in sitemap.js — the pages are
 * reachable only from the button on the corresponding table.
 */
export const FULL_TABLE_ROUTES = {
  projects: '/apps/project-management/full/projects',
  tokenState: '/apps/project-management/full/token-state',
  ordersMonitor: '/apps/sales-management/full/orders-monitor',
  productionJobs: '/apps/sales-management/full/production-jobs'
};

/** Where each full-view page sends you back to. */
export const FULL_TABLE_PARENTS = {
  projectMonitor: '/apps/project-management/project-monitor',
  orderMonitor: '/apps/sales-management/order-monitor'
};

/**
 * Rows per page once the table has a whole page to itself. The embedded tables
 * keep their own (smaller) page sizes — these apply only in `fullPage` mode.
 */
export const FULL_TABLE_PAGE_SIZE = {
  projects: 25,
  tokenState: 30,
  ordersMonitor: 25,
  productionJobs: 25
};
